(function (window, document) {
  "use strict";
  var themeFunctions = function (options) {
    var defaults = {
      // Defaults configuration
      deliveryDrawer: ".delivery-drawer__wrapper",
      openDeliveryButton: ".delivery-details-text",
      openDeliveryCart: ".header__delivery--dialog-cart",
      changeDeliveryButton: ".change-delivery-res",
      modalOverlay: ".modal_overlay",
      deliveryClose: ".delivery-type-close",
      searchModal: ".search-modal",
      searchClose: ".search-modal__close-button",
      menuToggles: ".submenu-link",
      sidebar: ".sidebar",
      menuItems: ".sidebar_drawer-open",
      subMenuItems: ".sidebar_subdrawer-open",
      sidebarTitle: ".sidebar-title",
      sidebarCloseButtons: ".sidebar_drawer_back",
      sidebarBackButtons: ".sidebar-back-button-unused",
      quickAddPlusButtons: ".collection-product__plus",
      quickAddMinusButtons: ".collection-product__minus",
      quickAddSubmitButtons: ".quick-add__submit",
      quickAddQuantityInputs: ".collection-quantity-selector",
    };

    this.settings = Object.assign({}, defaults, options);
    this.init();
    this.bindEvents();
  };

  themeFunctions.prototype.init = function () {
    this.deliveryDrawer = document.querySelector(this.settings.deliveryDrawer);
    this.openDeliveryButton = document.querySelector(
      this.settings.openDeliveryButton
    );
    this.openDeliveryCart = document.querySelector(
      this.settings.openDeliveryCart
    );
    this.changeDeliveryButton = document.querySelector(
      this.settings.changeDeliveryButton
    );
    this.modalOverlay = document.querySelector(this.settings.modalOverlay);
    this.searchModal = document.querySelector(this.settings.searchModal);
    this.searchClose = document.querySelector(this.settings.searchClose);
    this.menuToggles = document.querySelectorAll(this.settings.menuToggles);
    this.sidebar = document.querySelectorAll(this.settings.sidebar);
    this.menuItems = document.querySelectorAll(this.settings.menuItems);
    this.subMenuItems = document.querySelectorAll(this.settings.subMenuItems);
    this.sidebarTitle = document.querySelector(this.settings.sidebarTitle);
    this.sidebarCloseButtons = document.querySelectorAll(
      this.settings.sidebarCloseButtons
    );
    this.sidebarBackButtons = document.querySelectorAll(
      this.settings.sidebarBackButtons
    );
    this.quickAddPlusButtons = document.querySelectorAll(
      this.settings.quickAddPlusButtons
    );
    this.quickAddMinusButtons = document.querySelectorAll(
      this.settings.quickAddMinusButtons
    );
    this.quickAddSubmitButtons = document.querySelectorAll(
      this.settings.quickAddSubmitButtons
    );
    this.quickAddQuantityInputs = document.querySelectorAll(
      this.settings.quickAddQuantityInputs
    );
  };

  themeFunctions.prototype.bindEvents = function () {
    var self = this;

    // Assuming bodyElement needs to be defined or is accessible globally
    var bodyElement = document.body;

    themeFunctions.prototype.promptForDeliveryType = function () {
      if (!self.modalOverlay || !self.deliveryDrawer) return;
      self.modalOverlay.classList.add("submenu-open");
      document.body.classList.add("open__overlay", "overflow-hidden-tablet");
      self.deliveryDrawer.classList.add("submenu-open");
    };

    themeFunctions.prototype.openDeliveryButton = function () {
      self.promptForDeliveryType();
    };

    themeFunctions.prototype.handleDeliveryDrawerClick = function () {
      if (!self.modalOverlay || !self.deliveryDrawer) return;
      const expiresTime = getCookie("delivery_expires_time");
      if (expiresTime && parseInt(expiresTime, 10) > Date.now() && typeof clearReservationExpiredNotice === "function") {
        clearReservationExpiredNotice();
      }
      self.modalOverlay.classList.add("submenu-open");
      document.body.classList.add("open__overlay", "overflow-hidden-tablet");
      self.deliveryDrawer.classList.add("submenu-open");
    };

    themeFunctions.prototype.hidePromptForDeliveryType = function () {
      if (!self.modalOverlay || !self.deliveryDrawer) return;
      self.modalOverlay.classList.remove("submenu-open");
      document.body.classList.remove("open__overlay", "overflow-hidden-tablet");
      self.deliveryDrawer.classList.remove("submenu-open");
    };

    document.addEventListener("click", function (event) {
      // closest(), not matches(): the tap often lands on the +/- SVG icon
      // inside the button, which matches() misses - leaving part of the
      // button dead.
      if (event.target.closest(".collection-product__plus")) {
        // Additional check for maximum quantity
        const allowAction = typeof canAddToCart !== 'undefined' ? canAddToCart : (isDeliverySet === "true" || decideDeliveryLater === "1");
        
        if (allowAction) {
          let parent = event.target.closest(".quick-add");
          let item = event.target.closest(".product-item");

          if (!parent) {
            console.error("Parent .quick-add not found");
            return;
          }

          let quantityInput = parent.querySelector("input");
          if (!quantityInput) {
            console.error("Input inside .quick-add not found");
            return;
          }

          let productTitle = item.getAttribute("data-title");
          if (productTitle && productTitle.includes("Delivery Pass")) {
            if (parseInt(quantityInput.value) > 0) {
              console.error("Maximum quantity of Delivery Pass reached");
              item.querySelector(".product-error__container").innerHTML =
                "You can only add one Delivery Pass to the cart";
              return;
            }
          }

          let maxQuantity = parseInt(quantityInput.max);
          let currentQuantity = parseInt(quantityInput.value);

          if (isNaN(currentQuantity) || currentQuantity < maxQuantity) {
            // No updating-cart overlay here - the optimistic path must stay
            // tappable so rapid taps keep coalescing into the pending batch.
            let newQuantity = (isNaN(currentQuantity) ? 0 : currentQuantity) + 1;
            let itemId = parent
              .querySelector(".quick-add__quantity")
              .getAttribute("data-id");

            // Optimistic: display + badge/subtotal update now, then queue the
            // real write through the existing coalesced pipeline.
            applyOptimisticQuantityChange(itemId, newQuantity, getUnitPriceCentsFromQuickAdd(parent));
          } else {
            // Optionally, show an error message to the user
            console.error("Maximum quantity reached");
            item.querySelector(".product-error__container").innerHTML =
              "Maximum quantity in cart";
          }
        } else {
          console.log("Delivery type is not set.");
          if (window.StorePicker && typeof window.StorePicker.open === 'function') {
            window.StorePicker.open();
          } else if (typeof theme !== 'undefined' && typeof theme.promptForDeliveryType === 'function') {
            theme.promptForDeliveryType();
          }
        }
      }

      if (event.target.closest(".collection-product__minus")) {
        const allowAction = typeof canAddToCart !== 'undefined' ? canAddToCart : (isDeliverySet === "true" || decideDeliveryLater === "1");
        
        if (allowAction) {
          // Use event.target to reference the clicked element
          let parent = event.target.closest(".quick-add");
          let item = event.target.closest(".product-item");
          if (!parent) {
            console.error("Parent .quick-add not found");
            return; // Safety check
          }
          item.querySelector(".product-error__container").innerHTML = "";

          let itemId = parent
            .querySelector(".quick-add__quantity")
            .getAttribute("data-id");

          let quantityInput = parent.querySelector("input");

          if (!quantityInput) {
            console.error("Input inside .quick-add not found");
            return; // Safety check
          }

          let currentQuantity = Number(quantityInput.value);
          let unitPriceCents = getUnitPriceCentsFromQuickAdd(parent);
          // When quantity is 1, we want to send 0 as the quantity and also hide the container
          if (currentQuantity === 1) {
            // Optimistic: display (stepper hides itself) + badge/subtotal
            // update now, then queue the real write.
            applyOptimisticQuantityChange(itemId, 0, unitPriceCents);
          } else if (currentQuantity > 1) {
            // Decrement the quantity by 1 if it's more than 1
            let newQuantity = currentQuantity - 1;
            applyOptimisticQuantityChange(itemId, newQuantity, unitPriceCents);
          }
        } else {
          console.log("Delivery type is not set.");
          if (window.StorePicker && typeof window.StorePicker.open === 'function') {
            window.StorePicker.open();
          } else if (typeof theme !== 'undefined' && typeof theme.promptForDeliveryType === 'function') {
            theme.promptForDeliveryType();
          }
        }
      }
    });

    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    document.addEventListener(
      "input",
      debounce(function (event) {
        if (event.target.matches(".collection-quantity-selector")) {
          // Use canAddToCart from cart.js if available, otherwise fall back to old logic
          const allowAction = typeof canAddToCart !== 'undefined' ? canAddToCart : (isDeliverySet === "true" || decideDeliveryLater === "1");
          
          if (allowAction) {
            let parent = event.target.closest(".quick-add");
            let item = event.target.closest(".product-item");
            if (!parent) {
              console.error("Parent element '.quick-add' not found");
              return; // Exits if the parent container is not found
            }

            const inputElement = event.target;
            const value = inputElement.value.trim();
            var itemId = parent
              .querySelector(".quick-add__quantity")
              .getAttribute("data-id");
            var quantity = parseInt(value, 10);
            var maxQuantity =
              parseInt(inputElement.getAttribute("max"), 10) || Infinity; // Use input max or fallback to Infinity
            var unitPriceCents = getUnitPriceCentsFromQuickAdd(parent);

            // Handle the case when quantity is 0
            if (quantity === 0) {
              applyOptimisticQuantityChange(itemId, 0, unitPriceCents);
              return;
            }

            // Check if the product is a "Delivery Pass"
            let productTitle = item.getAttribute("data-title");
            if (productTitle && productTitle.includes("Delivery Pass") && quantity > 1) {
              console.error("Maximum quantity of Delivery Pass reached");
              inputElement.value = 1;
              applyOptimisticQuantityChange(itemId, 1, unitPriceCents);
              item.querySelector(".product-error__container").innerHTML =
                "You can only add one Delivery Pass to the cart";
              return;
            }

            if (/^\d+$/.test(value) && quantity > 0) {
              if (quantity <= maxQuantity) {
                // Proceed with update if within max limit
                applyOptimisticQuantityChange(itemId, quantity, unitPriceCents);
              } else {
                // Handle case where quantity exceeds max
                inputElement.value = maxQuantity; // Revert to max quantity
                applyOptimisticQuantityChange(itemId, maxQuantity, unitPriceCents);

                // Display error message
                console.error("Quantity exceeds maximum limit.");

                let errorContainer = item.querySelector(
                  ".product-error__container"
                );
                if (errorContainer) {
                  errorContainer.innerHTML = "Quantity exceeds maximum limit";
                  setTimeout(function () {
                    errorContainer.innerHTML = "";
                  }, 2000);
                }
              }
            } else {
              console.error("Invalid quantity input:", value);
              // Optionally, reset the input to a valid value or provide feedback to the user
            }
          } else {
            console.log("Delivery type is not set.");
            theme.promptForDeliveryType();
          }
        }
      }, 500)
    );

    // Menu drawers
    function closeDrawers() {
      var drawers = document.querySelectorAll(".sidebar");
      drawers.forEach(function (drawer) {
        drawer.classList.remove("open");
      });
      self.menuItems.forEach(function (menuItem) {
        menuItem.classList.remove("active_link");
        var menuItemLink = menuItem.querySelector("a");
        if (menuItemLink) menuItemLink.classList.remove("active_link");
      });
      document.querySelectorAll(".sidebar_menu button").forEach((btn) => {
        btn.classList.remove("active-button");
      });
    }

    this.menuToggles.forEach(function (menuToggle) {
      menuToggle.addEventListener("click", function (event) {
        var menuItem = this.getAttribute("data-menu-item");
        var matchingSidebar = document.querySelector(
          `.sidebar[data-menu-item="${menuItem}"]`
        );
        if (!matchingSidebar) return;

        matchingSidebar.classList.add("open");
        bodyElement.classList.add("open__overlay");
      });
    });

    document.querySelectorAll(".sidemenu___close").forEach((button) => {
      button.addEventListener("click", function () {
        // Get the 'data-panel' attribute of the clicked button
        const panelId = this.getAttribute("data-close");
        console.log(panelId);
        // Find the panel that matches the 'data-panel' attribute
        document.querySelectorAll(`.sub-sidebar_menu`).forEach((panel) => {
          panel.classList.remove("active-panel");
        });

        // Find the close button that matches the 'data-panel' attribute
        document.querySelectorAll(`.close-sub-menus`).forEach((button) => {
          button.classList.remove("show-close-button");
        });

        // Close the matching sidebar
        const sidebar = document.querySelector(
          `.sidebar[data-menu-item="${panelId}"]`
        );
        console.log(sidebar);
        if (sidebar) {
          const sidebarInner = sidebar.querySelector(".sidebar-inner");
          if (sidebarInner) sidebarInner.style.width = "auto";
          sidebar.classList.remove("open");
        }

        document.querySelectorAll(".sidebar_menu button").forEach((btn) => {
          btn.classList.remove("active-button");
        });

        // Remove the overlay
        bodyElement.classList.remove("open__overlay");
      });
    });

    document.querySelectorAll(".close-sub-menus").forEach((button) => {
      button.addEventListener("click", function (event) {
        this.classList.remove("show-close-button");
        document.querySelectorAll(".sub-sidebar_menu").forEach((panel) => {
          panel.classList.remove("active-panel");
        });
      });
    });

    // Listen for clicks on elements with the class '.text-with-icon'
    document.querySelectorAll(".sidebar_menu button").forEach((button) => {
      button.addEventListener("click", function () {
        // Check if the clicked button already has the 'active-button' class
        const isActive = this.classList.contains("active-button");

        // Add 'show-close-button' class to the close button
        document.querySelector(".close-sub-menus")?.classList.add("show-close-button");

        // Remove 'active-button' class from all buttons
        document.querySelectorAll(".sidebar_menu button").forEach((btn) => {
          btn.classList.remove("active-button");
        });

        if (!isActive) {
          // Add 'active-button' class to the clicked button if it wasn't active
          this.classList.add("active-button");
        }

        // Get the 'data-panel' attribute of the clicked button
        const panelId = this.getAttribute("data-panel");

        // Find the panel that matches the 'data-panel' attribute
        const panel = document.querySelector(
          '.sub-sidebar_menu[data-panel="' + panelId + '"]'
        );

        // Adjust the sidebar width
        const sidebarInner = document.querySelector(".sidebar-inner");
        if (sidebarInner) {
          sidebarInner.style.width = panel ? "700px" : "auto";
        }

        // Close all panels except the one that matches the clicked button
        document.querySelectorAll(".sub-sidebar_menu").forEach((otherPanel) => {
          if (otherPanel !== panel) {
            otherPanel.classList.remove("active-panel");
          }
        });

        // If the matching panel exists and it's not currently active, activate it
        if (panel && !panel.classList.contains("active-panel")) {
          panel.classList.add("active-panel");
        } else if (panel && panel.classList.contains("active-panel")) {
          // If the panel is already active, deactivate it and reset sidebar width
          panel.classList.remove("active-panel");
          if (sidebarInner) sidebarInner.style.width = "auto";
        }

        // Update link and drawer states accordingly
        document
          .querySelectorAll(".sidebar_subdrawer-open a")
          .forEach((link) => {
            link.classList.remove("active_link");
          });

        document.querySelectorAll(".sidebar_subdrawer").forEach((drawer) => {
          drawer.classList.remove("open");
        });

        // Only for the active panel, add 'active_link' and 'open' to related elements
        if (panel && panel.classList.contains("active-panel")) {
          // Add any additional actions for the active panel if needed
        }
      });
    });

    this.sidebarCloseButtons.forEach(function (closeButton) {
      closeButton.addEventListener("click", function (event) {
        event.stopPropagation();
        closeDrawers();
        document.querySelector(".sidebar-inner")?.style.setProperty("width", "auto");
        document.querySelectorAll(".sub-sidebar_menu").forEach((panel) => {
          panel.classList.remove("active-panel");
        });
        bodyElement.classList.remove("open__overlay");
      });
    });

    this.sidebarBackButtons.forEach(function (backButton) {
      backButton.addEventListener("click", function (event) {
        closeDrawers();
      });
    });

    this.menuItems.forEach(function (menuItem) {
      var drawer = menuItem.querySelector(".sidebar_drawer");
      var menuItemLink = menuItem.querySelector("a");
      if (!menuItemLink || !drawer) return;
      menuItemLink.addEventListener("click", function (event) {
        event.preventDefault();
        closeDrawers();
        this.classList.add("active_link");
        drawer.classList.toggle("open");
        const sidebar = menuItem.closest(".sidebar");
        if (sidebar) {
          sidebar.classList.add("submenu-active");
        }
      });
    });

    this.subMenuItems.forEach(function (subMenuItem) {
      var subDrawer = subMenuItem.querySelector(".sidebar_subdrawer");
      var menuItemLink = subMenuItem.querySelector("a");
      if (!menuItemLink || !subDrawer) return;
      menuItemLink.addEventListener("click", function (event) {
        event.preventDefault();
        this.classList.toggle("active_link");
        subDrawer.classList.toggle("open");
      });
    });

    document
      .querySelector(".delivery-type-close")
      ?.addEventListener("click", function () {
        self.deliveryDrawer?.classList.remove("submenu-open");
        bodyElement.classList.remove("open__overlay", "overflow-hidden-tablet");
      });        

    // The search modal keeps every search input in sync while typing
    // (main-search.js), so closing it would otherwise leave the typed term
    // sitting in the header bar. Clear all search inputs on every close path.
    function clearSearchInputs() {
      // Only the header bar + modal pair; leave e.g. the search page's
      // "Refine your search" box (prefilled with the current term) alone.
      ["Search-In-Template", "Search-In-Modal"].forEach((id) => {
        const input = document.getElementById(id);
        if (input) input.value = "";
      });
    }
    window.clearSearchInputs = clearSearchInputs;

    this.searchClose?.addEventListener("click", function () {
      self.searchModal?.classList.remove("open_modal");
      bodyElement.classList.remove("open__overlay", "overflow-hidden-tablet");
      clearSearchInputs();
    });

    this.modalOverlay?.addEventListener("click", function (event) {
      self.modalOverlay.classList.remove("submenu-open");
      bodyElement.classList.remove("open__overlay", "overflow-hidden-tablet");
      self.deliveryDrawer?.classList.remove("submenu-open");
      self.searchModal?.classList.remove("open_modal");
      document.querySelector(".sidebar-inner")?.style.setProperty("width", "auto");
      document.querySelectorAll(".sub-sidebar_menu").forEach((panel) => {
        panel.classList.remove("active-panel");
      });
      clearSearchInputs();
      closeDrawers();
    });

    if (!bodyElement.classList.contains("template-cart")) {
      var searchBar = document.getElementById("Search-In-Template");
      const overlayInput = document.getElementById("Search-In-Modal");
      if (!searchBar || !overlayInput || !self.modalOverlay || !self.searchModal) return;
      searchBar.onclick = function () {
        self.modalOverlay.classList.add("submenu-open");
        bodyElement.classList.add("open__overlay", "overflow-hidden-tablet");
        self.searchModal.classList.add("open_modal");
        overlayInput.focus();
      };
    }
  };

  var theme = new themeFunctions();
  window.theme = theme;
  
})(window, document);

var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!
var yyyy = today.getFullYear();
if (dd < 10) {
  dd = "0" + dd;
}
if (mm < 10) {
  mm = "0" + mm;
}
var isVIP = false;
var isGold = false;
var isFirstThreeOrders = false;
var weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

document.addEventListener("DOMContentLoaded", function () {
  
  document.addEventListener("keydown", function (event) {
    // Check if the ESC key is pressed
    if (event.key === "Escape" || event.keyCode === 27) {
      // Find the modal element
      var modal = document.querySelector(".search-modal.modal__content");

      // Check if the modal has the 'open_modal' class
      if (modal && modal.classList.contains("open_modal")) {
        // Remove the 'open_modal' class to close the modal
        modal.classList.remove("open_modal");
        //self.searchModal.classList.remove("open_modal");
        document.body.classList.remove("open__overlay", "overflow-hidden-tablet");
        if (typeof window.clearSearchInputs === "function") window.clearSearchInputs();
      }
    }
  });

  // Render the "items removed because they're unavailable at your store" notice.
  // Exposed globally so the cart store-change flow (cart.js) can show it immediately
  // after an AJAX cart refresh, not only on a full page load.
  window.showUnavailableItemsNotice = function (items) {
    if (!Array.isArray(items) || items.length === 0) return;

    const displayElement = document.querySelector(".unavailable-items");
    const displayElementList = document.querySelector(".unavailable-items-list");
    if (!displayElement || !displayElementList) return;

    displayElement.classList.add("show-unavailable-items");
    displayElementList.innerHTML = "";

    const list = document.createElement("ul");
    items.forEach((item) => {
      const listItem = document.createElement("li");
      listItem.textContent = item;
      list.appendChild(listItem);
    });
    displayElementList.appendChild(list);
  };

  // Retrieve the data from localStorage (covers the full-page-load path)
  const failedItemsData = localStorage.getItem("failedItems");

  // Check if there's any data to display
  if (failedItemsData && failedItemsData !== '""') {
    // Checks for non-empty string representation of an empty array
    const failedItems = JSON.parse(failedItemsData);
    window.showUnavailableItemsNotice(failedItems);
    // Clear the localStorage
    localStorage.removeItem("failedItems");
  }

  // Find the close button
  const closeButton = document.querySelector(".close-unavailable-items");

  if (closeButton) {
    // Add click event listener to the close button
    closeButton.addEventListener("click", () => {
      // Find the element with the .unavailable-items class
      const unavailableItemsElement =
        document.querySelector(".unavailable-items");

      if (unavailableItemsElement) {
        // Remove the .show-unavailable-items class
        unavailableItemsElement.classList.remove("show-unavailable-items");
      }
    });
  }

  // Select all .search__input elements on the page
  const searchInputs = document.querySelectorAll('.search__input:not([data-search-sync="false"])');

  // Function to synchronize all search input values
  function syncSearchInputs(sourceValue) {
    searchInputs.forEach((input) => {
      input.value = sourceValue;
    });
  }

  // Add input event listener to each search input
  searchInputs.forEach((input) => {
    input.addEventListener("input", function () {
      // Call sync function with the current value of the input being typed in
      syncSearchInputs(this.value);
    });
  });
});
